import React from 'react';
// ui
import ListItem from '@material-ui/core/ListItem';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemText from '@material-ui/core/ListItemText';
import Avatar from '@material-ui/core/Avatar';
import ToolTip from '@material-ui/core/Tooltip';
import { useTranslation } from 'react-i18next';
// utils
import { Checkbox, IconButton } from '@material-ui/core';
// icons
import DeleteIcon from '@material-ui/icons/Delete';
import PrintIcon from '@material-ui/icons/Print';
import RestoreIcon from '@material-ui/icons/Restore';
import { getUnitDetails } from 'utils/functions';

function LotListItem(props) {
  const {
    classes,
    product,
    lot,
    objects,
    index,
    checkbox,
    addToReturnLots,
    checked,
    deleteFnc,
    printFnc,
    toDeleteIds = [],
    restoreFnc,
  } = props;
  const { t } = useTranslation();

  const { unitCode, unitName } = getUnitDetails(objects.accounts);

  const id = lot.id || index;

  return (
    <ListItem dense key={`dispatch-lot-${id}`}>
      <ListItemAvatar>
        <Avatar className={classes.blue}>{product.name[0].toUpperCase()}</Avatar>
      </ListItemAvatar>
      <ListItemText
        primary={`${lot.id ? t('Pak number label', { id: lot.id }) + ', ' : ''}${t('Product label', { name: product.name })}`}
        secondary={t('Quantity label', { quantity: lot.quantity, unit: unitCode })}
      />
      {checkbox && (
        <ListItemSecondaryAction>
          <Checkbox
            edge="end"
            onChange={addToReturnLots}
            checked={checked}
            // @ts-ignore
            inputProps={{ 'data-id': id }}
          />
        </ListItemSecondaryAction>
      )}
      <ListItemSecondaryAction>
        {printFnc && (
          <ToolTip title={t('Print')} arrow>
            <IconButton onClick={printFnc} data-id={lot.id || index} size="medium">
              <PrintIcon fontSize="medium" />
            </IconButton>
          </ToolTip>
        )}
        {deleteFnc && (
          <ToolTip title={t('Delete')} arrow>
            <IconButton onClick={deleteFnc} data-id={lot.id || index} size="medium">
              <DeleteIcon fontSize="medium" />
            </IconButton>
          </ToolTip>
        )}
      </ListItemSecondaryAction>
    </ListItem>
  );
}

export default LotListItem;
